<template lang="pug">
  div
    table.table.table-sm
      thead
        tr
          th Valor inicial
          th Valor final
          th Multiplicador
          th(width="1")
      tbody
        tr(v-for="regra, i in model")
          td
            money.form-input.input-sm(v-model.number="regra.valor_inicial" disabled)
          td
            form(@submit.prevent="onSubmitRegra(regra)")
              a.btn.btn-link.px-2.mx-2.btn-action.tooltip(
                v-if="isRegraFinal(regra)"
                @click="onClickEdit(regra)"
                data-tooltip="Editar valor da regra final"
              )
                | ∞
              .input-group(v-else)
                money.form-input.input-sm(
                  v-model.number="regra.valor_final"
                  v-autofocus
                  :disabled="ultimaRegra !== regra"
                )
                a.btn.btn-link.btn-sm.input-group-btn.btn-action.tooltip(
                  v-if="ultimaRegra === regra"
                  @click="fillValorFinal(regra)"
                  data-tooltip="Preencher com o valor final máximo"
                )
                  | ∞
          td
            money.form-input.input-sm(
              v-model.number="regra.fator"
              @blur.native="onSubmitRegra(regra)"
            )
          td(width="1")
            a.btn.btn-link(@click="onRemove(i)" v-if='ultimaRegra === regra')
              i.fa.fa-trash-o.text-error
    .py-2(v-if="showAddRegra")
      a.btn.btn-link(@click="addRow")
        btn-content(icon="fa fa-plus" label="Adicionar regra")
</template>

<script>
import { deepClone } from 'paliari-js-utils'
import { VALOR_MAXIMO } from './validations'

export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    ultimaRegra() {
      return this.model[this.model.length - 1]
    },
    disabledAdd() {
      if (!this.ultimaRegra) return false
      return this.ultimaRegra.valor_final >= VALOR_MAXIMO
    },
    showAddRegra() {
      if (!this.ultimaRegra) return false
      if (this.ultimaRegra.valor_final > this.ultimaRegra.valor_inicial) {
        return this.ultimaRegra.valor_final < VALOR_MAXIMO
      }

      return false
    },
  },
  methods: {
    addRow() {
      const last = this.ultimaRegra
      const row = {
        valor_inicial: last ? last.valor_final + 0.01 : 0,
        valor_final: VALOR_MAXIMO,
        fator: 1,
      }
      this.model = [...this.model, row]
    },
    onRemove(index) {
      const replicated = deepClone(this.model)
      this.$delete(replicated, index)
      this.model = replicated
    },
    fillValorFinal(regra) {
      regra.valor_final = VALOR_MAXIMO
    },
    isRegraFinal(regra) {
      if (this.ultimaRegra === regra) {
        return regra.valor_final >= VALOR_MAXIMO
      }

      return false
    },
    onClickEdit(regra) {
      regra.valor_final = regra.valor_inicial + 0.01
    },
    onSubmitRegra(regra) {
      if (this.ultimaRegra === regra && this.value.valor_final < VALOR_MAXIMO)
        this.addRow()
    },
  },
}
</script>
